import moment from 'moment';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import InputGroup from 'reactstrap/lib/InputGroup';
import InputGroupAddon from 'reactstrap/lib/InputGroupAddon';
import InputGroupText from 'reactstrap/lib/InputGroupText';
import { EntityListContainer } from '../../../container/EntityListContainer';
import { addItem } from '../../../core/database/firebaseFunctions';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const RefForm = ({ onChange }) => {
    const [values, setValues] = useState({ ref: "", dorm: "", bathroom: "", suite: "", toilet: "", footage: "", garage: "", furniture: false, amount: "", video: "" })

    const generate = async () => {
        // setValues({});
        // onChange();
        // console.log({ values, json: JSON.stringify(values) })
        onChange(`<div style="display: none">${JSON.stringify(values)}</div>`)
        toast.success("Gerado!")
    }
    const clickKey = (event) => {
        if (event.keyCode === 13) {
            generate()
        }
    }

    // console.log({ values })
    return <div className="ref-form">
        <Row>
            <Col>
                <label className="label-input">Dormitório</label>
                <InputGroup>
                    <Input
                        className="input-qrcode"
                        placeholder="Insira o número de dormitório"
                        type="number"
                        onChange={(e) => setValues({ ...values, dorm: e.target.value })}
                        value={values && values.dorm}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
            <Col>
                <label className="label-input">Suíte</label>
                <InputGroup>
                    <Input
                        placeholder="Insira o número de suíte"
                        type="number"
                        onChange={(e) => setValues({ ...values, suite: e.target.value })}
                        value={values && values.suite}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <label className="label-input">Banheiro social</label>
                <InputGroup>
                    <Input
                        placeholder="Insira o número de banheiro social"
                        type="number"
                        onChange={(e) => setValues({ ...values, bathroom: e.target.value })}
                        value={values && values.bathroom}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
            <Col>
                <label className="label-input">Lavabo</label>
                <InputGroup>
                    <Input
                        placeholder="Insira o número de lavabo"
                        type="number"
                        onChange={(e) => setValues({ ...values, toilet: e.target.value })}
                        value={values && values.toilet}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <label className="label-input">Metragem</label>
                <InputGroup>
                    <Input
                        placeholder="Insira a metragem"
                        type="number"
                        onChange={(e) => setValues({ ...values, footage: e.target.value })}
                        value={values && values.footage}
                        onKeyDown={(e) => clickKey(e)}
                    />
                    <InputGroupAddon addonType="append" className="input-addon">m2</InputGroupAddon>
                </InputGroup>
            </Col>
            <Col>
                <label className="label-input">Vaga de garagem</label>
                <InputGroup>
                    <Input
                        placeholder="Insira o número de vaga de garagem"
                        type="number"
                        onChange={(e) => setValues({ ...values, garage: e.target.value })}
                        value={values && values.garage}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <label className="label-input">Valor</label>
                <InputGroup>
                    <InputGroupAddon addonType="prepend" className="input-addon">R$</InputGroupAddon>
                    <Input
                        placeholder="Insira o valor"
                        type="number"
                        onChange={(e) => setValues({ ...values, amount: e.target.value })}
                        style={{ borderRadius: 0 }}
                        value={values && values.amount}
                        onKeyDown={(e) => clickKey(e)}
                    />
                    <InputGroupAddon addonType="append" className="input-addon">.00</InputGroupAddon>
                </InputGroup>
            </Col>
            <Col>
            <label className="label-input">Vídeo</label>
            <InputGroup>
                <Input
                    placeholder="Insira o link do vídeo"
                    type="text"
                    onChange={(e) => setValues({ ...values, video: e.target.value })}
                    value={values && values.video}
                    onKeyDown={(e) => clickKey(e)}
                />
            </InputGroup>
        </Col>
        </Row>
        <Row>
            <Col>
                <label className="label-input">Código da Referência</label>
                <InputGroup>
                    <Input
                        className="input-qrcode"
                        placeholder="Insira o código da referência"
                        type="number"
                        onChange={(e) => setValues({ ...values, ref: e.target.value })}
                        value={values && values.ref}
                        onKeyDown={(e) => clickKey(e)}
                    />
                </InputGroup>
            </Col>
            <Col>
                <label className="label-input">Mobília</label>
                <InputGroup className="input-furniture">
                    <Input
                        addon
                        // placeholder="Com ou sem mobília"
                        // aria-label="Com ou sem mobília"
                        type="checkbox"
                        onChange={(e) => setValues(values => ({ ...values, furniture: !values.furniture }))}
                        style={{ marginRight: 10, marginTop: 4 }}
                        checked={values.furniture}
                    />
                    <label className="label-input" onClick={() => setValues(values => ({ ...values, furniture: !values.furniture }))}>Possui mobília?</label>
                </InputGroup>
            </Col>
        </Row>
        <div className="btn-generate">
            <Button
                className="btn-clear"
                color="link"
                onClick={() => setValues({ ref: "", dorm: "", bathroom: "", suite: "", toilet: "", footage: "", garage: "", furniture: false, amount: "", video: "" })}
            >
                Limpar campos
            </Button>
            <Button
                className="btn-generate-ref"
                color="primary"
                onClick={generate}
            >
                Gerar
            </Button>
        </div>
    </div>
}

function copyToClipboard(text) {
    toast.success("Copiado!")
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);

    }
    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
}

const RefScreen = ({ }) => {
    const [data, setData] = useState()

    // console.log({ data })
    return <div className="content ref-page">
        <div className="ref-header">
            <div className="ref-page-tile">Referências</div>
        </div>
        <div className="ref-page-subtitle-card">Gerar dados da referência</div>
        <Card className="card-ref">
            <CardBody>
                <RefForm onChange={setData} />
            </CardBody>
        </Card>
        {data ? <>
            <div className="ref-generated">
                <p className="ref-generated-subtitle">Dados gerados</p>
                <div style={{ flex: 1 }}></div>
                <Button
                    className="btn-print-ref"
                    color="warning"
                    onClick={() => copyToClipboard(data)}
                >
                    Copiar
                    <FileCopyIcon
                        style={{ width: 18, height: 18, marginLeft: 10 }}
                    />
                </Button>
            </div>
            <Card className="card-ref pointer" id="copy" onClick={() => copyToClipboard(data)}>
                <CardBody>
                    <pre className="ref-page-subtitle">{JSON.stringify(JSON.parse(data.replace(/<div style=".*">/g, "").replace(/<.*div>/g, "")), null, 2)}</pre>
                </CardBody>
            </Card>
        </> : <div />}
    </div>
}

export default RefScreen;